import { render, staticRenderFns } from "./AgenceMenu.vue?vue&type=template&id=630043b4&scoped=true&"
import script from "./AgenceMenu.vue?vue&type=script&lang=js&"
export * from "./AgenceMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630043b4",
  null
  
)

export default component.exports